import {
  BasicButton,
  DangerButton,
  GhostButton,
  PrimaryButton,
} from "@certn/cascadia";
import { useContext } from "react";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

export function LinkButtonControl(props: CascadiaControlProps) {
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);
  const { label, options, path } = props;
  const variant = options?.type ?? "basic";

  const Button = () => {
    switch (variant) {
      case "primary":
        return PrimaryButton;
      case "ghost":
        return GhostButton;
      case "danger":
        return DangerButton;
      default:
        return BasicButton;
    }
  };

  const onPress = () => {
    if (options?.link) {
      window.open(options.link, "_blank");
    }
  };

  if (isSummaryForPath?.(path) && options?.showInSummary === false) {
    return <></>;
  }

  return Button()({ children: label, rightIcon: options?.icon, onPress });
}

LinkButtonControl.displayName = "LinkButtonControl";

export const LinkButtonControlRenderer =
  withCascadiaControlProps(LinkButtonControl);
